// @flow
import * as React from 'react';

// Components
import { Icon } from 'components/atoms/Icon/';

type Props = {|
  /**
   * Property that the Slider of the library 'react-slick' injects to this
   * component in the Vehicle Builder
   */
  currentSlide: number,
  /**
   * Property that the Slider of the library 'react-slick' injects to this
   * component in the Vehicle Builder
   */
  slideCount: number
|};
/**
 *  This component wraps an Icon, taking out the properties the slider from
 *  the 'react-slick' library injects into the component when rendering
 *  the navigating arrows in the Vehicle Builder.
 */
export default function SliderIconWrapper({
  currentSlide,
  slideCount,
  ...other
}: Props) {
  return <Icon {...other} />;
}



// WEBPACK FOOTER //
// ./src/components/pages/VehiclePage/components/SliderIconWrapper/SliderIconWrapper.js